import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import OfferingCard from "../DroneXplore/OfferingCard";
import Hero from "../DroneXplore/Hero";
import DroneCategories from "../DroneXplore/DroneCategories";
import VendorAndCareer from "../DroneXplore/Vendor&Career";
import AcademicAndService from "../DroneXplore/Academic&Service";
import FeatureSection from "../DroneXplore/FeatureSection";
import FooterSection from "../DroneXplore/FooterSection";
import { Header, Footer } from "../shared";

const AllBlogPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <Hero />
      <OfferingCard />
      <DroneCategories />
      <VendorAndCareer />
      <AcademicAndService />
      <FeatureSection />
      {/* <FooterSection /> */}
      <Footer />
    </div>
  );
};

export default AllBlogPage;
